import { FEATURE_FLAGS, useFlag } from './feature-flags';

/**
 * Whether sent emails can be logged to the agency's AMS. The server needs both gates on
 * (mailbox.AmsLoggingEnabled), so with either off it refuses the switch and logs nothing.
 */
export const useAmsLoggingEnabled = (): boolean => {
  const isMailboxEnabled = useFlag(FEATURE_FLAGS.MAILBOX);
  const isAmsLoggingFlagOn = useFlag(FEATURE_FLAGS.MAILBOX_AMS_LOGGING);
  return isMailboxEnabled && isAmsLoggingFlagOn;
};
